import { Component } from "@angular/core";

import { Config } from "src/app/config";
import { ExamService } from "src/app/services/exam.service";
import { ModalDialogService } from "src/app/modals/modaldialog/modaldialog.service";
import { EditNameComponent } from "src/app/modals/editname/editname.component";
import { UploadButtonCompleteResponse } from "src/app/directives/uploadbutton.directive";
import { LibraryVideo } from "src/app/models/libraryvideo";
import { Exam } from "src/app/models/exam";

@Component({
  templateUrl: "./libraryvideos.component.html",
  styleUrls: ["./libraryvideos.component.scss"],
})
export class LibraryVideosComponent {
  exam: Exam;
  uploadUrl: string;
  uploadFolder: string;
  uploadingVideo: boolean;
  uploadingProgress: number;
  showVideo: { [key: string]: boolean };

  constructor(private modalDialogService: ModalDialogService, private examService: ExamService) {
    this.exam = this.examService.currentExam;
    this.uploadUrl = Config.SERVER_API_UPLOAD;
    this.uploadFolder = Config.SERVER_UPLOADFOLDER;
    this.uploadingVideo = false;
    this.showVideo = {};
  }

  onUploadProgress(progress: number): void {
    this.uploadingVideo = true;
    this.uploadingProgress = progress;
  }
  onUploadComplete(data: UploadButtonCompleteResponse): void {
    let video = new LibraryVideo();

    let count = 0;
    let found: boolean;
    do {
      found = false;
      video.name = data.filename + (count == 0 ? "" : "_" + count);
      if (this.exam.library.checkVideoNameInUse(video.name)) {
        found = true;
      }
    } while (found);

    video.source = data.filename;
    this.exam.library.videos.push(video);
    this.uploadingVideo = false;
  }
  onUploadError(msg: string): void {
    this.modalDialogService.showAlert(Config.APP_NAME, msg);
    this.uploadingVideo = false;
  }

  onEditVideo(video: LibraryVideo): void {
    const modal = this.modalDialogService.createModal();
    modal.setTitle("Video name");
    modal.setButtonCancelOk();
    const component = modal.setBodyComponent(EditNameComponent);
    component.createFormWithValues(video.name);
    component.onFormStatusChanges.subscribe(invalid => {
      modal.buttons[1].disabled = invalid;
    });
    modal.show().subscribe(
      button => {
        if (button.index == 0) {
          modal.close();
        } else if (button.index == 1) {
          if (component.hasErrors()) {
            return;
          }
          const formValues = component.values;
          formValues.name = formValues.name.trim();
          if (this.exam.library.checkVideoNameInUse(formValues.name, video)) {
            this.modalDialogService.showAlert(Config.APP_NAME, "The name is already in use");
            return;
          }
          video.name = formValues.name;
          modal.close();
        }
      },
      error => {},
      () => {
        this.modalDialogService.dismissModal(modal);
      },
    );
  }

  onDeleteVideo(video: LibraryVideo): void {
    let index = this.exam.library.videos.indexOf(video);
    if (index >= 0) {
      this.modalDialogService.showConfirmation(Config.APP_NAME, "Are you sure to delete the video?", () => {
        // Yes
        this.exam.library.videos.splice(index, 1);
      });
    }
  }
}
